import React, { useState, useEffect } from "react";
import FilterDropdown from "./filter_dropdown";

const TableFilter = ({filterOptions, changeQuery}) => {
  const [searchValues, setSearchValues] = useState([]);

  const onSelectOption = (id, title) => {
    setSearchValues([...searchValues, {id, title, value: ''}])
  }

  const onFinishTyping = (id, value) => {
    setSearchValues(searchValues.map(object => {
      if(object.id === id) {
        return {
          ...object,
          value: value,
        }
      } else return object;
    }))
  }

  const onRemove = (id) => {
    setSearchValues(searchValues.filter(s => s.id !== id))
  }

  useEffect(() => {
    changeQuery(searchValues)
  }, [searchValues])

  return (
    <div className="d-flex filter-container pe-4 py-3">
      <FilterDropdown 
        optionData={filterOptions} 
        onSelect={onSelectOption}
      />
      <div className="ps-4">
        {
          searchValues.map((s, i) => (
            <SearchInput 
              id={s.id}
              title={s.title}
              key={`filter-input-${s.id}`}
              active={i === searchValues.length - 1}
              onFinish={onFinishTyping}
              onRemove={onRemove}
            />
          ))
        }
      </div>
    </div>
  );
};

const SearchInput = ({id, title, active, onFinish, onRemove}) => {
  const [current, setCurrent] = useState("");
  const onInput = (e) => {
    e.currentTarget.parentNode.setAttribute('data-value', e.currentTarget.value)
  }

  const onSumbit = () => {
    onFinish(id, current)
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => onFinish(id, current), 1000);
    return () => clearTimeout(timeoutId);
  }, [current]);

  return (
    <label className="input-sizer ms-2 my-1">
      <span>{title}: </span>
      <input
        type="text"
        size="1"
        placeholder=""
        autoFocus={true}
        value={current}
        onInput={onInput}
        disabled={!active}
        onChange={(e) => setCurrent(e.target.value)}
        onSubmit={onSumbit}
      />
      <div className="remove pointer" onClick={() => onRemove(id)}>
        <i className='bx bx-x text-primary font-size-20'></i>
      </div>
    </label>
  );
};

export default TableFilter;
